import Progress from './Progress';
export type { ProgressCircleProps } from './ProgressCircle';
export type { ProgressLineProps } from './ProgressLine';

export default Progress;
